<script>
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import {ref} from "vue";
import {useRoute} from "vue-router";
import Swal from "sweetalert2";
import {useStore} from "vuex";
import $ from "jquery";
import FreeWorld from "@/assets/js/FreeWorld";
import NavbarPage from "@/components/assetComponents/NavbarPage.vue";

export default {
  name: "DetailsEducation",
  components: {NavbarPage, LoadingPage},

  setup() {
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0

    let edu_id = useRoute().params.id
    let loading = ref(false)

    let data = ref(null)
    let mark = ref(false)

    let store = useStore()
    let products = ref(store.state.order.products)
    let counts = ref(store.state.order.orders_count)
    let price = ref(store.state.order.orders_price)

    function load_education() {

      loading.value = true
      FreeWorld.Heisenberg({action: 'one_education', education_id: edu_id,} , 'education' , true).then((result) => {

        loading.value = false
        let res = result.data
        data.value = res[0]
        data.value.order_count_select = 0
        data.value.type = 'education'
        if (data.value.mark == 1) {
          mark.value = true
        }

        products.value.forEach((item) => {

          if (data.value.id == item.id && data.value.type == 'education') {
            data.value.order_count_select = item.order_count_select
          }

        })

      }).catch((result) => {

        loading.value = false
        if (result.message == 'Network Error') {
          Swal.fire({
            icon: 'error',
            confirmButtonText: 'تلاش مجدد',
            text: 'لطفا فیلتر شکن را خاموش کرده یا وضعیت اینترنت را برسی کنید',
          }).then((result) => {
            if (result.isConfirmed) {
              load_education()
            }
          })
        } else {
          Swal.fire({
            icon: 'error',
            confirmButtonText: 'تلاش مجدد',
            text: '!خطای ارتباط با سرور',
          }).then((result) => {
            if (result.isConfirmed) {
              load_education()
            }
          })
        }
      })


    }
    load_education()

    function mark_prod() {

      let div_mark = document.getElementById('div_mark')

      div_mark.style.pointerEvents = 'none'
      mark.value = !mark.value

      let data = {
        action: 'add',
        item_id: edu_id,
        type: 'education',
      }
      FreeWorld.Heisenberg(data , 'user_marke' , true).then((result) => {
        let res = result.data

        setTimeout(() => {
          if (res.event == 'mark delete') {
            mark.value = false
          } else if (res.event == 'mark add') {
            mark.value = true
          }
          div_mark.style.pointerEvents = 'auto'
        }, 1000)

      }).catch(() => {

        setTimeout(() => {
          mark.value = !mark.value
          div_mark.style.pointerEvents = 'auto'
        }, 1000)

        console.log('don`t mark')
      })


    }

    function buy_education(action) {

      if (action == 'cancel') {

        $("#orders").addClass('animate__animated animate__fadeOutDown')

        setTimeout(()=>{
          data.value.order_count_select = 0
          store.commit('ProductUpdate', data.value)
          products.value = store.state.order.products
          counts.value = store.state.order.orders_count
          price.value = store.state.order.orders_price
        },900)


      } else {


        products.value = store.state.order.products

        if (products.value.length == 0) {
          data.value.order_count_select = 1
          store.commit('ProductUpdate', data.value)
          products.value = store.state.order.products
          counts.value = store.state.order.orders_count
          price.value = store.state.order.orders_price

        } else if (products.value.length != 0) {

          products.value.forEach((item) => {

            if (item.type != 'education') {

              Swal.fire({
                title: "!...متاسفم",
                text: "در حال حاضر محصول در سبد خرید شما وجود دارد!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#28a745",
                cancelButtonColor: "#d33",
                confirmButtonText: "ساخت سبد خرید جدید",
                cancelButtonText: "انصراف",
                showClass: {
                  popup: 'animate__animated animate__bounceInDown'
                },
                hideClass: {
                  popup: 'animate__animated animate__bounceOutUp'
                }
              }).then((result) => {

                if (result.isConfirmed) {


                  Swal.fire({
                    text: "!با ساختن سبد خرید جدید سبد خرید قبلی شما حذف خواهد شد",
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#28a745",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "متوجه شدم",
                    cancelButtonText: "انصراف",
                    showClass: {
                      popup: 'animate__animated animate__bounceInDown'
                    },
                    hideClass: {
                      popup: 'animate__animated animate__bounceOutUp'
                    }
                  }).then((result) => {
                    if (result.isConfirmed) {

                      store.commit('EmptyBasket')
                      data.value.order_count_select = 1
                      store.commit('ProductUpdate', data.value)
                      products.value = store.state.order.products
                      counts.value = store.state.order.orders_count
                      price.value = store.state.order.orders_price

                      Swal.fire({
                        text: "سبد خرید جدید شما با موفقیت ایجاد شد",
                        confirmButtonText: "متوجه شدم",
                        icon: "success"
                      });

                    }
                  });


                }

              });

            } else {

              data.value.order_count_select = 1
              store.commit('ProductUpdate', data.value)
              products.value = store.state.order.products
              counts.value = store.state.order.orders_count
              price.value = store.state.order.orders_price

            }

          })

        }
      }

    }


    return {

      loading,
      data,
      mark,
      mark_prod,
      products,
      counts,
      price,
      buy_education,

    }
  }
}
</script>

<template>

  <LoadingPage v-if="loading"></LoadingPage>

  <div dir="ltr" id="main" :class="loading ? 'activeClass' : '' " class="bg-main">
    <div class="div-top-arrow bg-color justify-content-between d-flex align-items-center ">

      <div id="div_mark" @click="mark_prod" class="d-flex align-items-center justify-content-center">
        <img v-if="mark" style="width: 25px" src="../assets/img/save_mark.svg" alt="">
        <img v-else style="width: 25px" src="../assets/img/bookmark-white.svg" alt="">
      </div>

      <div class="d-flex align-items-center">
        <p class="m-0">
          جزئیات آموزش
        </p>
        <div onclick="history.back()">
          <img class="svg-arrow" src="../assets/img/back.svg" alt="">
        </div>
      </div>

    </div>
    <br>
    <br>
    <br>

    <div v-if="data != null " class="animate__animated animate__fadeIn">

      <div class="div_img_products p-body my-3">
        <img class="w-100 h-100 rounded-4" :src="data.profile_pic" alt="">
      </div>

      <div class="p-body mb-2">
        <div class="d-flex p-3 bg-white rounded-4 border-costom justify-content-between align-items-center">

          <div v-if="data.already_buy == 0 && data.order_count_select != 1 " @click="buy_education"
               class="bg-color rounded-5 d-flex p-2 align-items-center">
            <img style="width: 15px" class="" src="../assets/img/add-to-cart.svg" alt="">
            <p class="text-white font-5 px-2 m-0">
              خرید
            </p>
          </div>

          <div v-if="data.already_buy == 1" class="bg-color rounded-5 d-flex p-2 align-items-center">
            <p class="text-white font-5 px-2 m-0">
              خریداری شده
            </p>
          </div>

          <div v-if="data.order_count_select == 1" @click="buy_education('cancel')"
               class="bg-danger rounded-5 d-flex p-2 align-items-center">
            <p class="text-white font-5 px-2 m-0">
              لغو خرید
            </p>
          </div>


          <p class="m-0 font-4">{{ data.name }}</p>
        </div>
      </div>

      <div class="p-body mb-2">
        <div class="d-flex p-3 bg-white rounded-4 border-costom justify-content-between align-items-center">

          <div class="d-flex">
            <div class="d-flex align-items-center bg-costom rounded-pill mx-1 px-1 py-2">

              <p class="m-0 mx-2 font-color font-5">
                <span>{{ data.discount }}</span>
                <span>%</span>
              </p>
            </div>
          </div>
          <div class="d-flex">
            <p class="d-flex font-color font-4 mx-3 m-0 font-4">
              <span class="mx1">تومان</span>
              <span class="mx1">{{ data.off_price.toLocaleString() }}</span>
            </p>

            <p v-if="data.off_price != null" class="font-4 m-0 "
               :class="data.off_price == null ? 'font-color font-4' : 'text-decoration-line-through font-5' ">
              <span class="mx1">{{ data.price.toLocaleString() }}</span>
              <span v-if="data.off_price == null " class="mx1">تومان</span>
            </p>
          </div>

        </div>
      </div>

      <div class="p-body mb-2">
        <div class="d-flex flex-column p-3 bg-white rounded-4 border-costom align-items-center">
          <p class="text-end font-4 font-bold w-100">
            :توضیحات دوره
          </p>
          <div dir="rtl">
            <p class="m-0 font-4">{{ data.description }}</p>
          </div>

        </div>
      </div>

      <div class="p-body mb-2">
        <div class="d-flex p-3 bg-white rounded-4 border-costom justify-content-between align-items-center">
          <p class="px-2 d-flex font-4 m-0">
            <span>ساعت</span>
            &nbsp;
            <span>{{ data.course_length }}</span>
          </p>

          <p class="m-0 font-bold font-4">
            طول دوره
          </p>
        </div>
      </div>

      <div v-if="data.already_buy == 0 " class="p-body mb-2">
        <a :href="data.vedio_link" target="_blank"
           class="d-flex align-items-center text-decoration-none justify-content-end bg-white rounded-4 p-2">
          <p class="font-4 m-0 font-color font-bold">
            مشاهده پیش نمایش دوره
          </p>
          <img style="right: 0;width: 50px; height: 50px" class="rounded-4 ml-15" src="../assets/img/play_video.svg"
               alt="">
        </a>
      </div>

      <div v-else class="p-body mb-2">
        <a :href="data.vedio_link" target="_blank"
           class="d-flex align-items-center text-decoration-none justify-content-center bg-color rounded-4 p-2">
          <p class="font-4 m-0 text-white font-bold">
            دانلود فایل دوره
          </p>
          <img style="width: 12%; height: 12%" class="rounded-4 ml-2" src="../assets/img/download.png" alt="">
        </a>
      </div>

    </div>

    <div v-if="products.length > 0 " class="">

      <br>
      <br>
      <br>
      <br>
      <div id="orders" class="p-body div_orders animate__animated animate__fadeInUp">

        <div class="h-100 rounded-pill shadow-costom bg-white d-flex align-items-center justify-content-between px-2">
          <div>
            <router-link :to="{name:'OrdersPage'}"
                         class="d-flex font-4 p-3 bg-color rounded-pill text-decoration-none align-items-center border-costom text-white">
              <img style="width:20px " class="mx-2" src="../assets/img/shopping-bag.svg" alt="">

              <p class="m-0">
                مشاهده سبد خرید
              </p>
            </router-link>
          </div>
          <div>
            <p class="m-0 d-flex font-4 justify-content-end">
              <span>تومان</span>
              <span class="font-bold mx-2">{{ price.toLocaleString() }}</span>
            </p>
            <p class="m-0 d-flex font-4 justify-content-end">
              <span>.قلم سفارش داده اید</span>
              <span class="font-bold mx-2">{{ counts }}</span>
            </p>
          </div>
        </div>
      </div>

    </div>

  </div>

  <div id="web" :class="loading ? 'activeClass' : '' " class="bg-main">

    <NavbarPage></NavbarPage>
    <div v-if="data !== null " class="rounded-4 d-flex justify-content-between align-items-center bg-white p-3 mb-4 w-75 ma-auto">
      <p class="font-3 font-bold font-color">{{ data.name }}</p>

      <div id="div_mark" @click="mark_prod" class="d-flex align-items-center justify-content-center">
        <img v-if="mark" style="width: 25px" src="../assets/img/save_mark_web.svg" alt="">
        <img v-else style="width: 25px" src="../assets/img/bookmark-white-web.svg" alt="">
      </div>
    </div>

    <div v-if="data !== null " class="bg-white p-4 rounded-4 w-75 m-auto">

      <div class="div_img_products mb-3">
        <img class="w-100 h-100 rounded-4" :src="data.profile_pic" alt="">
      </div>

      <div class="mb-2">
        <div class="d-flex p-3 bg-white rounded-4 border-costom justify-content-between align-items-center">
          <p class="m-0 font-4">{{ data.name }}</p>

          <div v-if="data.already_buy == 0 && data.order_count_select != 1 " @click="buy_education"
               class="bg-color rounded-5 d-flex p-2 align-items-center">
            <img style="width: 15px" class="" src="../assets/img/add-to-cart.svg" alt="">
            <p class="text-white font-5 px-2 m-0">
              خرید
            </p>
          </div>

          <div v-if="data.already_buy == 1" class="bg-color rounded-5 d-flex p-2 align-items-center">
            <p class="text-white font-5 px-2 m-0">
              خریداری شده
            </p>
          </div>

          <div v-if="data.order_count_select == 1" @click="buy_education('cancel')"
               class="bg-danger rounded-5 d-flex p-2 align-items-center">
            <p class="text-white font-5 px-2 m-0">
              لغو خرید
            </p>
          </div>
        </div>
      </div>

      <div class="mb-2">
        <div class="d-flex p-3 bg-white rounded-4 border-costom justify-content-between align-items-center">
          <div class="d-flex">
            <p v-if="data.off_price != null" class="font-4 m-0 "
               :class="data.off_price == null ? 'font-color font-4' : 'text-decoration-line-through font-5' ">
              <span v-if="data.off_price == null " class="mx1">تومان</span>
              <span class="mx1">{{ data.price.toLocaleString() }}</span>
            </p>

            <p class="d-flex font-color font-4 mx-3 m-0 font-4">
              <span class="mx1">{{ data.off_price.toLocaleString() }}</span>
              <span class="mx1">تومان</span>
            </p>
          </div>

          <div class="d-flex">
            <div class="d-flex align-items-center bg-costom rounded-pill mx-1 px-1 py-2">

              <p class="m-0 mx-2 font-color font-5">
                <span>{{ data.discount }}</span>
                <span>%</span>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="mb-2">
        <div class="d-flex flex-column p-3 bg-white rounded-4 border-costom align-items-center">
          <p class="text-end font-4 mb-2 font-bold w-100">
            توضیحات دوره :
          </p>

            <p class="m-0 w-100 font-4">{{ data.description }}</p>
        </div>
      </div>

      <div class="mb-2">
        <div class="d-flex p-3 bg-white rounded-4 border-costom justify-content-between align-items-center">
          <p class="m-0 font-bold font-4">

            طول دوره
          </p>
          <p class="px-2 d-flex font-4 m-0">{{ data.course_length }}</p>
        </div>
      </div>

      <div v-if="data.already_buy == 0 " class="mb-2 ">
        <a :href="data.vedio_link" target="_blank" class="d-flex shadow-costom align-items-center justify-content-center position-relative text-decoration-none bg-white rounded-4 p-3">
          <img style="right: .2rem;width: 3rem; height: 3rem" class="rounded-3 position-absolute" src="../assets/img/play_video.svg" alt="">

          <p class="font-4 m-0 font-color font-bold">مشاهده پیش نمایش دوره</p>
        </a>
      </div>

      <div v-else class="mb-2">
        <a :href="data.vedio_link" target="_blank"
           class="d-flex align-items-center text-decoration-none justify-content-center bg-color rounded-4 p-2">
          <p class="font-4 m-0 text-white font-bold">
            دانلود فایل دوره
          </p>
          <img style="width: 12%; height: 12%" class="rounded-4 ml-2" src="../assets/img/download.png" alt="">
        </a>
      </div>

    </div>

  </div>

</template>

<style scoped>

.div_img_products {
  width: 100%;
  height: 300px;
}

.div_orders {
  position: fixed;
  bottom: 0;
  width: 100%;
  max-width: 700px;
  padding: .8rem;
}

.div_orders > div{
  padding: .7rem;
}

</style>